import BaseModal from '../Shared/BaseModal.js';
import { useState } from "react";
import { RoundedButton, ButtonCorner } from '../Buttons/RoundedButton.js';
import {
    FormGroup,
    Form,
    Input,
    Label,
    Container,
    Row,
    Col,
    Spinner,
    FormFeedback
} from "reactstrap";
import { Color } from '../../constants/colors';

const ConfirmSubscriptionModal = ({ isOpen, isLoading, handleClose, submitHandler, currentLicenseCount, newLicenseCount }) => {
    const nonBreakingSpace = "\u00A0";

    const headerContent =
        <Container>
            <Row>
                <Col className="d-flex centered-flex-content">
                    <h5 className="modal-title text-black">Confirm Subscription Update</h5>
                </Col>
            </Row>

        </Container>;

    const bodyContent =
        <>
            <Form className="no-margin-top">
                <Container className="no-margin-x no-margin-top">
                    {isLoading &&
                        <Spinner className="centered-loader" />
                    }
                    {!isLoading &&
                        <>
                        <div className="background-color-green no-margin-x py-3 text-white">
                            <Row className="ml-5 font-size-18px"><small>New License Count:  <b className="font-size-21px">{newLicenseCount}</b></small></Row>
                            </div>
                            <Row>{nonBreakingSpace}</Row>
                            <Row className="ml-5">
                                <span className="h4">Confirming this update will result in the following changes:</span>
                            </Row>
                            <Row>{nonBreakingSpace}</Row>
                            <Row className="ml-5">
                                <ul>
                                    <li>
                                        Your total license count will change from {currentLicenseCount} to {newLicenseCount}
                                    </li>
                                    <li>
                                        Your new recurring subscription fee will be <b>${newLicenseCount * 15} / month*</b>
                                    </li>
                                </ul>
                            </Row>
                            <div className="background-color-lightGray no-margin-x py-3">
                                <Row className="ml-5"><small><span className="required-indicator">*</span>Newly added licenses will be prorated until the next billing cycle.</small></Row>
                                <Row className="ml-5"><small><span className="required-indicator">*</span>Removed licenses will be canceled at the start of the next billing cycle.</small></Row>
                                <Row className="ml-5"><small><span className="required-indicator">*</span>Cost estimate above excludes any discounts or custom pricing.</small></Row>
                            </div>
                            <Row>{nonBreakingSpace}</Row>

                            <Row>{nonBreakingSpace}</Row>
                            <Row>{nonBreakingSpace}</Row>
                            <Row className="d-flex justify-content-end mr-5">
                                <RoundedButton
                                    hoverColor={Color.DeleteRed}
                                    hoverTextColor={Color.White}
                                    hoverOutlineColor={Color.DeleteRed}
                                    textColor={Color.Red}
                                    buttonColor={Color.White}
                                    className="mr-3"
                                    outlineColor={Color.DeleteRed}
                                    cornerRadius={ButtonCorner.SevenPX}
                                    clickHandler={handleClose}
                                    type="button"
                                    width="100px"
                                    text="Cancel" />
                                <RoundedButton
                                    hoverColor={Color.Black}
                                    hoverTextColor={Color.White}
                                    hoverOutlineColor={Color.Black}
                                    textColor={Color.White}
                                    buttonColor={Color.DarkBlue}
                                    outlineColor={Color.DarkBlue}
                                    cornerRadius={ButtonCorner.SevenPX}
                                    clickHandler={submitHandler}
                                    type="button"
                                    width="150px"
                                    text="Update Subscription"
                                />
                            </Row>
                        </>
                    }
                </Container>
            </Form>
        </>
    return (
        <>
            <BaseModal
                headerClassName="background-color-lightGray"
                isOpen={isOpen}
                toggle={handleClose}
                headerContent={headerContent}
                bodyContent={bodyContent}
                size="lg"
                bodyClassName="no-margin-x no-margin-top"
            />
        </>

    );
}

export default ConfirmSubscriptionModal;